module.exports = __webpack_public_path__ + "img/icon-info-white.70174af3.svg";